import React, { useContext } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaStar,
  FaMapMarkerAlt,
  FaLocationArrow,
  FaPhone,
  FaComment,
} from "react-icons/fa";
import "../../../assets/css/Customer/CustomerRide/CustomerRideCard.css";
import AppContext from "../../../context/AppContext";

const CustomerRideCard = ({
  rideData,
  activeTab,
  showCallMessage = true,
  showCancelButton = false,
  onCall,
  onMessage,
  onCardClick,
}) => {
  const navigate = useNavigate();
  const { setSelectedRideforFindingDriver } = useContext(AppContext);

  const handleCall = (e) => {
    e.stopPropagation();
    if (onCall) onCall(rideData);
    else window.location.href = `tel:${rideData.driver?.phone}`;
  };

  const handleMessage = (e) => {
    e.stopPropagation();
    if (onMessage) onMessage(rideData);
    else navigate("/customer-chat");
  };

  const handleRateRide = (e) => {
    e.stopPropagation();
    navigate("/customer-rating", {
      state: {
        tdride_id: rideData.id,
        tddriver_id: rideData.tddriver?.id,
      },
    });
  };

  const handleNameClick = (ride) => {
    setSelectedRideforFindingDriver(ride);
    if (ride.status === "request" || ride.status === "bid_sent") {
      navigate("/customer-finding-driver");
    } else if (ride.status === "accept" || ride.status === "ongoing") {
      navigate("/customer-accept-ride");
    } else if (ride.status === "complete") {
      if (!ride.has_rated) {
        navigate("/customer-rating", {
          state: {
            tdride_id: ride.id,
            tddriver_id: ride.tddriver?.id,
          },
        });
      }
    } else if (ride.status === "cancelled") {
      navigate("/customer-myride");
    }
  };

  const avatarLetter = rideData.driver?.name?.charAt(0).toUpperCase() || "D";

  const getfare = () => {
    if (rideData.status === "request") return rideData.offeredFare;
    return (
      rideData.bookingbiddings?.find((b) => b.status === "accepted")
        ?.bidAmounts || rideData.offeredFare
    );
  };

  return (
    <Card
      className="ride-card"
      onClick={() => handleNameClick(rideData)}
      style={{ cursor: "pointer" }}
    >
      <Card.Body className="p-0">
        <div className="ride-card-driver-section">
          <Row className="align-items-start g-0">
            <Col xs="auto" className="me-2">
              <div className="ride-card-driver-avatar">{avatarLetter}</div>
            </Col>
            <Col>
              <div className="d-flex justify-content-between align-items-center">
                <p
                  className="ride-card-driver-name"
                  style={{ marginBottom: 0 }}
                >
                  {rideData.bookingType}
                </p>
                <span className="ride-card-fare-right">Rs.{getfare()}</span>
              </div>
              <div className="d-flex align-items-center">
                <FaStar className="ride-card-star" />
              </div>
              <p className="ride-card-driver-datetime">
                {rideData.bookingDate}
              </p>
            </Col>
          </Row>
        </div>

        <div className="ride-card-locations">
          <div className="ride-card-location-item">
            <FaMapMarkerAlt className="ride-card-location-icon pickup" />
            <span className="ride-card-location-text">
              {rideData.pickuplocation}
            </span>
          </div>
          <div className="ride-card-location-item mt-1">
            <FaLocationArrow className="ride-card-location-icon dropoff" />
            <span className="ride-card-location-text">
              {rideData.dropofflocation}
            </span>
          </div>
        </div>
        {rideData.status === "completed" && (
          <div className="ride-card-action-buttons">
            {rideData.has_rated ? (
              <div className="ride-card-rated-badge">
                <FaStar color="#FFD700" size={14} />
                <span>Rated</span>
              </div>
            ) : (
              <Button
                className="ride-card-rate-btn w-100"
                onClick={handleRateRide}
              >
                ⭐ Rate this ride
              </Button>
            )}
          </div>
        )}

        {showCallMessage && (
          <div className="ride-card-action-buttons">
            <Row className="g-2">
              <Col xs={6}>
                <Button
                  className="ride-card-call-btn w-100"
                  onClick={handleCall}
                >
                  <FaPhone size={15} />
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  className="ride-card-message-btn w-100"
                  onClick={handleMessage}
                >
                  <FaComment size={15} />
                </Button>
              </Col>
            </Row>
          </div>
        )}

        {showCancelButton && <div className="ride-card-cancel-wrapper"></div>}
      </Card.Body>
    </Card>
  );
};

export default CustomerRideCard;